// Default chat-area when no agent is selected. Includes a mobile-only
// affordance to open the sidebar drawer, since the drawer is not visible
// on small screens until the hamburger / this button opens it.

import { useTranslation } from '../i18n';

export interface EmptyChatStateProps {
  onOpenSidebar?: () => void;
}

export function EmptyChatState({ onOpenSidebar }: EmptyChatStateProps) {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col h-full w-full items-center justify-center p-8 bg-background"
      data-testid="empty-chat-state"
    >
      <div className="max-w-md text-center">
        <h2 className="text-body-chat font-medium text-foreground mb-2">
          {t('chat.empty.title')}
        </h2>
        <p className="text-body text-muted-foreground leading-relaxed mb-4">
          {t('chat.empty.subtitle')}
        </p>
        {onOpenSidebar && (
          <button
            type="button"
            onClick={onOpenSidebar}
            data-testid="open-sidebar-from-empty"
            className="md:hidden inline-flex items-center justify-center px-4 py-2 rounded-md bg-card hover:bg-popover text-body text-foreground focus:outline-none focus:ring-2 focus:ring-border"
          >
            {t('chat.empty.openSidebar')}
          </button>
        )}
      </div>
    </div>
  );
}
